var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44px",
    height: "44px",
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Platforma_ALL",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ALL---3.3---B\\u0142\\u0119dna",
    transform: "translate(-298.000000, -425.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(240.000000, 367.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(54.000000, 54.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(5.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31,18.0774008 C31,15.2733503 28.6893552,13 25.839304,13 C23.6202661,13 21.7292733,14.377605 21,16.3110856 C20.2707267,14.377605 18.3797339,13 16.160696,13 C13.3106448,13 11,15.2733503 11,18.0774008 C11,19.41976 11.5307062,20.6397661 12.395087,21.5475957 L12.395087,21.5480992 L21,31 L29.6044012,21.5480992 C30.4692938,20.6402697 31,19.41976 31,18.0774008",
    id: "Fill-33",
    fill: "#708BE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42,26.8687025 C39.4093714,35.6108284 31.17762,42 21.4235188,42 C9.59185772,42 0,32.5979937 0,21 C0,9.40200634 9.59185772,0 21.4235188,0 C25.6097176,0 29.514624,1.17621893 32.8142778,3.21059231",
    id: "Stroke-42",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,5 C39.6842732,8.90754244 42,14.5664703 42,20.8611678 C42,21.5830368 41.9696474,22.2965059 41.9102812,23",
    id: "Stroke-43",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.1fb473f25fc0032cb8151d289197e1df.svg";
export { ForwardRef as ReactComponent };